import moment from "moment";
import { apiClient } from '@repo/shared';

const initialiseNewClass = () => {
  return {
    id: null,
    title: "",
    time: "",
    day: "",
    classYears: "",
    schoolYear: "",
    semester: "",
    location: "",
    school: {id: 0},
    teacher: "",
    createdAt: "",
    updatedAt: "",
    duration: 40,
  };
}

const getAll = async () => {
  const classes = await apiClient.get("/api/classes");

  console.log('GOT CLASSES', classes);

  classes.sort((a,b) => {
    return moment(b.fromDate).format('X')-moment(a.fromDate).format('X')
  });
  return classes;
};

const getAllForYearAndSemester = async (year, semester) => {
  const classes = await apiClient.get(`/api/classes?forYear=${year}&forSemester=${semester}`);
  return classes;
};

const getLinkedClass = async (classId) => {
  const classes = await apiClient.get(`/api/classes/${classId}/linked`);
  console.log('LINKED CLASSES INNIT', classes);
  const clazz = classes?.[0];
  if (clazz) {
    clazz.dates = clazz.dates.map(d => new Date(Date.parse(d)));
  }
  return clazz;
}

const getYearCountsPerTeacher = async (forSemester) => {
  const yearCountsPerTeacher = await apiClient.get(`/api/teacher/yearCounts?semester=${forSemester}`);

  return yearCountsPerTeacher;
};

const getAllForSchool = async schoolId => {
  const classes = await apiClient.get(`/api/classes?schoolId=${schoolId}`);
  return classes;
};

const get = async (id) => {
  console.log('In classservice.get for id', id);
  const classes = await apiClient.get(`/api/classes/${id}`);
  const clazz = classes?.[0];
  clazz.dates = clazz.dates.map(d => new Date(Date.parse(d)));
  return clazz;
};

const getEmailBody = async (id, semester) => {
  const emailBody = await apiClient.get(`/api/classes/${id}/email?semester=${semester}`);
  console.log(emailBody);
  return emailBody;
};

const prepForSaving = (clazz, studentsForClass) => {
  clazz.schoolId = clazz.school.id;
  clazz.studentIds = studentsForClass.map(s => s.id);
  clazz.dates = clazz.dates.map(cd => new Date(cd));
}

const create = async (clazz, studentsForClass) => {
  prepForSaving(clazz, studentsForClass);
  return await apiClient.post(`/api/classes`, clazz);
};

const saveNotes = async(id, notes) => {
  return await apiClient.post(`/api/classes/${id}/notes`, {notes});
};

const update = async (id, clazz, studentsForClass) => {
  prepForSaving(clazz, studentsForClass);
  return await apiClient.post(`/api/classes/${id}`, clazz);
};

const remove = async (id) => {
  const classes = await apiClient.delete(`/api/classes/${id}`);
  return classes;
};

const classChronoSortFunc = (a, b) => {
  const DAYS = {sonntag: 0, montag:1, dienstag:2, mittwoch:3, donnerstag:4, freitag:5, samstag:6};
  const aDayValue = DAYS[a.day.toLowerCase()];
  const bDayValue = DAYS[b.day.toLowerCase()];
  const aTimeValue = parseInt(a.time?.replace(':', ''));
  const bTimeValue = parseInt(b.time?.replace(':', ''));
  if (aDayValue === bDayValue) {
    if (aTimeValue === bTimeValue) {
      if (a.teacher === b.teacher) {
        return `${b.semester}`.localeCompare(`${a.semester}`)
      } else {
        return `${a.teacher}`.localeCompare(`${b.teacher}`)
      }
    } else { 
      return aTimeValue - bTimeValue;
    }
  } else {
    return aDayValue - bDayValue;
  }
}

const ClassService = {
  getAllForYearAndSemester,
  getAllForSchool,
  getAll,
  get,
  getLinkedClass,
  getEmailBody,
  create,
  update,
  remove,
  saveNotes,
  initialiseNewClass,
  classChronoSortFunc,
  getYearCountsPerTeacher
};

export default ClassService;